const DEFAULT_CONFIG = {
    cinemaLeftLateralSpace: 16,
    marginBetweenTiles: 8,
    defaultNumberOfTiles: 5,
    clusters: [
        {
            belongs: (width) => width <= 497,
            tiles: 2,
        },
        {
            belongs: (width) => 497 < width && width <= 636,
            tiles: 3,
        },
        {
            belongs: (width) => 636 < width && width <= 767,
            tiles: 4,
        },
    ],
};

const SIMPLE_DEFAULT_CONFIG = {
    cinemaLeftLateralSpace: 16,
    marginBetweenTiles: 8,
    defaultNumberOfTiles: 12,
    clusters: [
        {
            belongs: (width) => width <= 350,
            tiles: 2,
        },
        {
            belongs: (width) => 350 < width && width <= 490,
            tiles: 3,
        },
        {
            belongs: (width) => 490 < width && width <= 660,
            tiles: 4,
        },
        {
            belongs: (width) => 660 < width && width <= 800,
            tiles: 5,
        },
    ],
};

export const calculateTileDimension = (
    cinemaInjectionContainerWidth,
    { cinemaLeftLateralSpace, defaultNumberOfTiles, marginBetweenTiles, clusters } = DEFAULT_CONFIG
) => {
    const numberOfVisibleTiles = calculateNumberOfVisibleTiles(cinemaInjectionContainerWidth, defaultNumberOfTiles, clusters);
    const cinemaAvailableSpace = cinemaInjectionContainerWidth - cinemaLeftLateralSpace;
    const totalNumberOfVisibleTiles = numberOfVisibleTiles + 0.5;

    const totalMarginForVisibleTiles = numberOfVisibleTiles * marginBetweenTiles;

    const width = (cinemaAvailableSpace - totalMarginForVisibleTiles) / totalNumberOfVisibleTiles;
    const height = (4 / 3) * width;

    return {
        width,
        minimumWidth: 50,
        minimumHeight: 50,
        height,
        numberOfVisibleTiles,
    };
};

export const calculateTileDimensionSquareRatio = (
    cinemaInjectionContainerWidth,
    { defaultNumberOfTiles, clusters } = SIMPLE_DEFAULT_CONFIG
) => {
    const numberOfVisibleTiles = calculateNumberOfVisibleTiles(cinemaInjectionContainerWidth, defaultNumberOfTiles, clusters);

    return {
        width: "96px",
        minimumWidth: 96,
        minimumHeight: 96,
        height: "96px",
        numberOfVisibleTiles,
    };
};

const calculateNumberOfVisibleTiles = (cinemaInjectionContainerWidth, defaultNumberOfTiles, clusters) => {
    const cluster = clusters.find(({ belongs }) => belongs(cinemaInjectionContainerWidth));
    return cluster ? cluster.tiles : defaultNumberOfTiles;
};
